module.exports = __webpack_public_path__ + "img/detail_title.411fb432.png";